import { io } from "socket.io-client";

/**
 * Crea una conexión Socket.IO para un proceso específico.
 * @param {string} processId - ID del proceso a suscribirse
 * @param {string} server - URL del servidor Socket.IO
 * @param {(update: any) => void} onUpdate - Callback que recibe cada actualización
 * @returns {() => void} Función para desconectar y limpiar
 */
export function connectToProcess(processId, server, onUpdate) {
  if (!processId) {
    console.warn("connectToProcess: processId no definido");
    return () => {};
  }

  // Conectar al servidor
  const socket = io(server, { transports: ["websocket"] });

  // Cuando el socket se conecta
  socket.on("connect", () => {
    console.log("✅ Conectado a Socket.IO", socket.id);
    socket.emit("subscribeProcess", processId); // Suscribirse a la sala correcta
  });

  // Escuchar actualizaciones de proceso
  socket.on("processUpdated", (update) => {
    console.log("Update recibido:", update);
    if (onUpdate) onUpdate(update);
  });

  socket.on("disconnect", (reason) => {
    console.log("🔌 Desconectado del proceso", processId, "razón:", reason);
  });

  // Devuelve función de limpieza
  return () => {
    socket.emit("unsubscribeProcess", processId);
    socket.disconnect();
    console.log("🛑 Socket desconectado", processId);
  };
}
